<template>
    <zoezi-autocomplete
        :label="label"
        :items="routes"
        :value="value"
        @input="$emit('input', $event)"
        :clearable="clearable"
        :itemMissing="(value) => `${this.$translate('Selected page not available')}: ${value}`"
    />
</template>

<script>
import ZoeziAutocomplete from './ui/form/Autocomplete.vue';

export default {
    name: 'zoezi-page-setting',

    props: ['value', 'label', 'clearable', 'routeFilter', 'props'],

    components: {
        ZoeziAutocomplete
    },

    computed: {
        routes() { // filtered + sorted
            let routes = this.$root.siteconfig.routes.concat(); // Make a copy
            if (this.routeFilter) {
                routes = routes.filter(r => this.routeFilter(r, this.props));
            }

            routes = routes.map(r => ({
                text: `${r.props.name} (${r.props.path})`,
                value: r.props.path,
            })).sort((a, b) => a.text.localeCompare(b.text));

            return routes;
        },
    }
}
</script>
